// src/Components/ShippingForm/ShippingFields.js
import React from "react";
import FormField from "./FormField";
import { COUNTRIES } from "./countries";

export default function ShippingFields({ form, onChange }) {
  const requiresState = ["US", "CA", "AU"].includes(form.countryCode);

  return (
    <>
      <FormField
        label="Full Name"
        name="fullName"
        value={form.fullName}
        onChange={onChange}
        required
      />

      <FormField
        label="Phone"
        name="phone"
        value={form.phone}
        onChange={onChange}
        required
      />

      <FormField
        label="Country"
        name="countryCode"
        value={form.countryCode}
        onChange={onChange}
        required
        options={COUNTRIES}
      />

      <FormField
        label="State / Province / Region"
        name="state"
        value={form.state}
        onChange={onChange}
        required={requiresState}
      />

      <FormField
        label="City"
        name="city"
        value={form.city}
        onChange={onChange}
        required
      />

      <FormField
        label="Address"
        name="address"
        value={form.address}
        onChange={onChange}
        required
      />

      <FormField
        label="Postal Code"
        name="postalCode"
        value={form.postalCode}
        onChange={onChange}
        required
      />

      <div className={`form-group ${form.notes ? "has-value" : ""}`}>
        <textarea name="notes" value={form.notes || ""} onChange={onChange} />
        <label>Delivery notes (optional)</label>
      </div>
    </>
  );
}